import { ComponentPropsWithoutRef } from 'react';
import { CampaignGivingSpace } from '@givebutter/types';
import { maskDecimal } from '@givebutter/util';

interface ShoutoutCardProps extends ComponentPropsWithoutRef<'div'> {
  shoutout: CampaignGivingSpace;
}
export const ShoutoutCard = (props: ShoutoutCardProps) => {
  const { shoutout, className = '', ...rest } = props;
  return (
    <div
      {...rest}
      className={`bg-shoutout flex flex-col items-start justify-between gap-2 rounded-2xl p-4 drop-shadow-lg backdrop-blur-[500px] xl:p-5 2xl:px-8 2xl:py-6 ${className}`}
    >
      <div className="text-4xl font-bold xl:text-5xl 2xl:text-6xl">
        {renderDonationAmount(shoutout)}
      </div>
      <div className="text-3xl 2xl:text-4xl">{shoutout.name}</div>
      <div className="text-base xl:text-xl 2xl:text-2xl">{shoutout.time_since}</div>
    </div>
  );
};

const renderDonationAmount = (shoutout: CampaignGivingSpace) => {
  const { amount, donation_amount } = shoutout;
  if (parseInt(donation_amount) > 0 && amount === null) {
    return '';
  } else {
    return `$${maskDecimal(shoutout.donation_amount)}`;
  }
};
